


















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CompassDetails extends Vue {
  @Prop() readonly label: string | undefined;
  @Prop() readonly details: string | undefined;
  @Prop() readonly hovered: string | undefined;
  @Prop() readonly opened: boolean | undefined;

}

